import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute } from "../Core/PrivateRoute";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import Modal, { ModalSize } from "../misc/components/modal";
import { EcgAnalysisDetail } from "./EcgAnalysisDetail";
import { EcgAnalysisSetScreen } from "./EcgAnalysisSetScreen";
import { EcgSessionScreen } from "./EcgSessionListScreen";
import { EcgSiteView } from "./EcgSiteView";

export const EcgRoot = () => {
    return (
        <Routes>
            <Route
                path=":sessionId"
                element={
                    <PrivateRoute permissions={[PermissionEnum.AccessSingleECGSession]}>
                        <Modal size={ModalSize.ExtraLarge} show={true}>
                            <div className="modal-body">
                                <EcgSiteView />
                            </div>
                        </Modal>
                    </PrivateRoute>
                }
            />
            <Route
                path="analysis"
                element={
                    <PrivateRoute permissions={[PermissionEnum.OverreadECGSession, PermissionEnum.ReviewECGSession]}>
                        <EcgAnalysisSetScreen />
                    </PrivateRoute>
                }
            />

            <Route
                path="analysis/:analysisSetTestId/:analyseMode"
                element={
                    <Modal size={ModalSize.ExtraLarge} show={true}>
                        <div className="modal-body">
                            <EcgAnalysisDetail />
                        </div>
                    </Modal>
                }
            />
        </Routes>
    );
};
